export default class BaseObject {
  dup() {
    return Object.assign(Object.create(this), this)
  }
}
